import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  initEaState,
  changeEaState,
  getEaPlanDetail,
} from '@store/actions/eaAction';
import { searchSuitability } from '@store/actions/planListAction';

import EaLnb from '@components/ea/EaLnb';
import EaPlanInfoMain from '@container/ea/EaPlanInfoMain';
import AgreeInfoMain from '@container/ea/AgreeInfoMain';
import EaAuthMain from '@container/ea/EaAuthMain';
import SignAgree from '@container/ea/SignAgree';
import CustomerInfoCheck from '@container/ea/CustomerInfoCheck';
import OtherInfoCheck from '@container/ea/OtherInfoCheck';
import NotificationDuty from '@container/ea/NotificationDuty';
import NotificationEdit from '@components/ea/NotificationEdit';
import EaPdfViewerMain from '@container/ea/EaPdfViewerMain';
import LifePlannerSign from '@container/ea/LifePlannerSign';
import RegisterAccountMain from '@container/ea/RegisterAccountMain';

import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';

import jumpToPagePlugin from '@container/pdfviewer/jumpToPagePlugin';
import { getToday } from '@common/utils/date';

const EaPracticeMain = props => {
  const dispatch = useDispatch();
  const { setEaMainPopup, planEstablishNo, applicationNo } = props;
  const { changeOrientation, isPortrait } = $hooks.useDevice();

  const [title1Status, setTitle1Status] = useState(false);
  const [title2Status, setTitle2Status] = useState(false);
  const [title3Status, setTitle3Status] = useState(false);
  const [title4Status, setTitle4Status] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pdfPageNum, setPdfPageNum] = useState('1');
  const [isClosePopup, setIsClosePopup] = useState(false);
  const [isAuthPopup, setIsAuthPopup] = useState(false);
  const [isCompletePopup, setIsCompletePopup] = useState(false);
  const [isNotCompletePopup, setIsNotCompletePopup] = useState(false);
  const [notCompleteMsg, setNotCompleteMsg] = useState('');
  const [notCompletePageNum, setNotCompletePageNum] = useState(0);
  const [notCompletePdfPageNum, setNotCompletePdfPageNum] = useState(0);
  const [isUpdatePage, setIsUpdatePage] = useState('');
  const [isVariable, setIsVarialble] = useState(false);
  const [practiceSignName, setPracticeSignName] = useState('');
  const [practiceSignature, setPracticeSignature] = useState('');

  const jumpToPagePluginInstance = jumpToPagePlugin();
  const { jumpToPage } = jumpToPagePluginInstance;

  const {
    planMainInfo,
    authCustomerInfo,
    completePage,
    bookmark,
    authTime,
    completePdfPage,
    pdfPath,
    contract,
    signData,
    customer,
    isShowLnb,
    contractSign,
  } = useSelector(state => state.eaReducer);
  const { userInfo, channelInfo } = useSelector(state => state.userReducer);
  const { suitabilityInfo } = useSelector(state => state.planListReducer);

  // 전자청약 닫기 버튼
  const onClickEaCloseBtn = () => {
    setIsClosePopup(true);
  };

  // 페이지 변경
  const handlePageChange = (value, page) => {
    if (pdfPath === '') {
      if (value === 0 || value === 1) {
        setCurrentPage(value);
      } else {
        const now = getToday('yyyyMMddHHmm');
        if (authTime !== '') {
          if (now - authTime > 100) {
            setIsAuthPopup(true);
          } else {
            if (value === 11) {
              let checkPage = [];
              if (page === 'account') {
                checkPage = [2, 3, 4, 5, 7, 8, 9];
              } else {
                checkPage = [2, 3, 4, 5, 7, 8, 9, 10];
              }
              if (checkPage.length > completePage.length) {
                const notCompletePage = checkPage.filter(
                  data => !completePage.includes(data),
                );
                const minNotCompletePage = Math.min(...notCompletePage);
                if (minNotCompletePage !== 8) {
                  setNotCompletePageNum(minNotCompletePage);
                  const title = handleNotCompleteMsg(minNotCompletePage);
                  setNotCompleteMsg(
                    `${title} 문서가 작성되지 않아 청약 완료가 불가합니다. 청약문서 작성 완료해 주세요.`,
                  );
                  setIsNotCompletePopup(true);
                } else {
                  const filterBookmark = bookmark.filter(
                    data => data.ableYn && data.code !== '',
                  );
                  if (filterBookmark.length > completePdfPage.length) {
                    const notCompletePdfPage = filterBookmark.filter(
                      data => !completePdfPage.includes(data.code),
                    )[0];
                    const minNotCompletePdfPageNum =
                      notCompletePdfPage.pn.split(',')[0];
                    setNotCompletePdfPageNum(Number(minNotCompletePdfPageNum));
                    setNotCompleteMsg(
                      `${notCompletePdfPage.title} 문서가 작성되지 않아 청약 완료가 불가합니다. 청약문서 작성 완료해 주세요.`,
                    );
                    setIsNotCompletePopup(true);
                    setNotCompletePageNum(minNotCompletePage);
                  } else {
                    setIsCompletePopup(true);
                  }
                }
              } else {
                setIsCompletePopup(true);
              }
              // setIsCompletePopup(true);
            } else {
              setCurrentPage(value);
            }
          }
        } else {
          setIsAuthPopup(true);
        }
      }
    } else {
      if (isUpdatePage !== '') {
        setCurrentPage(value);
      } else {
        setIsUpdatePage(value);
      }
    }
  };

  // 완료안된페이지 문서 이름
  const handleNotCompleteMsg = value => {
    switch (value) {
      case 3:
        return '전자문서 서명 동의';
      case 4:
        return '고객 정보 확인';
      case 5:
        return '기타 정보 확인';
      case 7:
        return '계약 전 알릴 의무';
      case 9:
        return $utils.checkLP(channelInfo.cdVal)
          ? '라이프파트너 서명'
          : '보험설계사 서명';
      case 10:
        return '계좌등록';
      default:
        return '';
    }
  };

  // 전자청약서 목차 클릭
  const handleEaBookmarkClick = value => {
    if (pdfPath === '') {
      const now = getToday('yyyyMMddHHmm');
      if (authTime !== '') {
        if (now - authTime > 100) {
          setIsAuthPopup(true);
        } else {
          setCurrentPage(8);
          const splitPage = value.split(',');
          if (currentPage === 8) {
            jumpToPage(Number(splitPage[0]) - 1);
            setPdfPageNum(splitPage[0]);
          }
          setPdfPageNum(splitPage[0]);
        }
      } else {
        setIsAuthPopup(true);
      }
    } else {
      if (isUpdatePage !== '') {
        setCurrentPage(8);
        const splitPage = value.split(',');
        if (currentPage === 8) {
          jumpToPage(Number(splitPage[0]) - 1);
          setPdfPageNum(splitPage[0]);
        }
        setPdfPageNum(splitPage[0]);
      } else {
        setIsUpdatePage(value);
      }
    }
  };

  // 전자청약 닫기 버튼 팝업 확인 버튼
  const handleCloseConfirmBtn = () => {
    dispatch(initEaState());

    setTimeout(
      function () {
        setEaMainPopup(false);
      }.bind(this),
      200,
    );

    if (isPortrait) changeOrientation('landscape'); // 세로일때 가로 전환
  };

  // 다음 클릭
  const handleNextClick = () => {
    // 다음 클릭 시 미입력 페이지로 이동하도록 수정 SAT-2039
    let checkPage = [2, 3, 4, 5, 7, 8, 9, 10];

    if (checkPage.length > completePage.length && currentPage !== 6) {
      let minNotCompletePage;

      // 현재 페이지의 이후 문서 중 완료되지 않은 페이지 추출
      const notCompletePage = checkPage.filter(
        data => currentPage < data && !completePage.includes(data),
      );

      if (notCompletePage.length > 0) {
        minNotCompletePage = Math.min(...notCompletePage);
        if (minNotCompletePage !== 8) {
          setCurrentPage(minNotCompletePage); // 페이지 이동
        } else {
          const filterBookmark = bookmark.filter(
            data => data.ableYn && data.code !== '',
          );
          if (filterBookmark.length > completePdfPage.length) {
            const notCompletePdfPage = filterBookmark.filter(
              data => !completePdfPage.includes(data.code),
            )[0];
            const minNotCompletePdfPageNum =
              notCompletePdfPage.pn.split(',')[0];
            handleEaBookmarkClick(minNotCompletePdfPageNum); // 페이지 이동
          }
        }
      } else {
        setCurrentPage(currentPage + 1);
      }
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  // 미완료된 페이지 이동
  const pageJumpNotCompletePage = () => {
    setIsNotCompletePopup(false);
    if (notCompletePageNum !== 8) {
      setCurrentPage(notCompletePageNum);
    } else {
      handleEaBookmarkClick(String(notCompletePdfPageNum));
    }
  };

  // 초기 조회
  useEffect(() => {
    dispatch(initEaState());
    // plan 상세조회
    dispatch(
      getEaPlanDetail({
        planEstablishNo: planEstablishNo,
        isPracticeMode: true,
      }),
    );
    // 적합성 조회
    dispatch(
      searchSuitability({
        applicationNo: applicationNo,
        callback: data => setIsVarialble(data),
      }),
    );
  }, [planEstablishNo]);

  // 목차 펼치기 접기
  useEffect(() => {
    if (currentPage > 0 && currentPage < 4) {
      setTitle1Status(true);
      setTitle2Status(false);
      setTitle3Status(false);
      setTitle4Status(false);
      setPdfPageNum('1');
    }
    if (currentPage > 3 && currentPage < 8) {
      setTitle1Status(false);
      setTitle2Status(true);
      setTitle3Status(false);
      setTitle4Status(false);
      setPdfPageNum('1');
    }
    if (currentPage === 8) {
      setTitle1Status(false);
      setTitle2Status(false);
      setTitle3Status(true);
      setTitle4Status(false);
    }
    if (currentPage === 9) {
      setTitle1Status(false);
      setTitle2Status(false);
      setTitle3Status(true);
      setTitle4Status(false);
      setPdfPageNum('1');
    }
    if (currentPage > 9) {
      setTitle1Status(false);
      setTitle2Status(false);
      setTitle3Status(false);
      setTitle4Status(true);
      setPdfPageNum('1');
    }
  }, [currentPage]);

  // 특정 장표 숨기기
  useEffect(() => {
    const changeBookmark = bookmark.map(data => {
      if (data.code === '1718') {
        return {
          ...data,
          ableYn:
            ['5', '6', '7', '8'].includes(
              customer.owner.rsdn.substring(6, 7),
            ) || contract.etc.taxDutyYn !== '1'
              ? true
              : false,
        };
      } else if (data.code === '1752') {
        return {
          ...data,
          ableYn:
            contract.notificationDuty.notificationType1.category1.q08 &&
            contract.notificationDuty.notificationType1.category1.q08.specific
              ? true
              : false,
        };
      } else if (data.code === '1753') {
        return {
          ...data,
          ableYn:
            contract.notificationDuty.notificationType1.category1.q08 &&
            contract.notificationDuty.notificationType1.category1.q08.decrement
              ? true
              : false,
        };
      }
      {
        return { ...data };
      }
    });

    dispatch(
      changeEaState({
        type: 'bookmark',
        data: changeBookmark,
      }),
    );
  }, [
    contract.etc.taxDutyYn,
    contract.notificationDuty.notificationType1.category1.q08,
    customer.owner.rsdn,
  ]);

  // 세로모드일때 LNB 외부 클릭 시 LNB 닫기
  const handleCloseLnb = () => {
    if (isPortrait && isShowLnb) {
      dispatch(
        changeEaState({
          type: 'isShowLnb',
          data: false,
        }),
      );
    }
  };

  return (
    <>
      <div className="container">
        <div
          className="dim"
          style={{
            display: isPortrait && isShowLnb ? 'block' : 'none',
          }}
          onClick={handleCloseLnb}
        />
        <EaLnb
          title1Status={title1Status}
          setTitle1Status={setTitle1Status}
          title2Status={title2Status}
          setTitle2Status={setTitle2Status}
          planMainInfo={planMainInfo}
          onClickEaCloseBtn={onClickEaCloseBtn}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          handlePageChange={handlePageChange}
          completePage={completePage}
          bookmark={bookmark}
          dept2Bookmark={bookmark.filter(
            data => data.ableYn && data.dept === 2,
          )}
          title3Status={title3Status}
          setTitle3Status={setTitle3Status}
          onClickEaBookmark={handleEaBookmarkClick}
          pdfPageNum={pdfPageNum}
          title4Status={title4Status}
          setTitle4Status={setTitle4Status}
          completePdfPage={completePdfPage}
          isVariable={isVariable}
          isPortrait={isPortrait}
          isShowLnb={isShowLnb}
          userType={channelInfo.cmnCdNm}
          lpDeptYn={channelInfo.lpDeptYn}
        />
        <div className="content">
          {currentPage === 0 && (
            // 설계정보
            <EaPlanInfoMain
              planMainInfo={planMainInfo}
              onClickNext={handleNextClick}
              isPracticeMode={true}
              isForiegner={['5', '6', '7', '8'].includes(
                customer.owner.rsdn.substring(6, 7),
              )}
            />
          )}
          {currentPage === 1 && (
            // 필수, 선택 동의
            <AgreeInfoMain
              onClickNext={handleNextClick}
              applicationNo={applicationNo}
              isPracticeMode={true}
            />
          )}
          {currentPage === 2 && (
            // 본인 인증
            <EaAuthMain
              authCustomerInfo={authCustomerInfo}
              onClickNext={handleNextClick}
              handlePageChange={handlePageChange}
              setIsAuthPopup={setIsAuthPopup}
              completePage={completePage}
              applicationNo={applicationNo}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isPracticeMode={true}
            />
          )}
          {currentPage === 3 && (
            // 전자문서 서명 동의
            <SignAgree
              applicationNo={applicationNo}
              onClickNext={handleNextClick}
              isPracticeMode={true}
              practiceSignName={practiceSignName}
              setPracticeSignName={setPracticeSignName}
              practiceSignature={practiceSignature}
              setPracticeSignature={setPracticeSignature}
            />
          )}
          {currentPage === 4 && (
            // 고객정보 확인
            <CustomerInfoCheck
              applicationNo={applicationNo}
              isPracticeMode={true}
              onClickNext={handleNextClick}
              insuredPrspCustNo={planMainInfo.insuredPrspCustNo}
              ownerPrspCustNo={planMainInfo.ownerPrspCustNo}
              optionalRiderList={planMainInfo.optionalRiderList}
            />
          )}
          {currentPage === 5 && (
            // 기타정보확인
            <OtherInfoCheck
              customer={customer}
              applicationNo={applicationNo}
              currentPage={currentPage}
              isPracticeMode={true}
              onClickNext={handleNextClick}
              isVariable={suitabilityInfo.variableProductYn === 'Y'}
              isUsdSuitability={
                suitabilityInfo.usdProductYN === 'Y' &&
                contractSign
                  .find(a => 517 === a.step)
                  ?.newContract?.list2?.replaceAll('-', '') > 20220630
              }
              suitabilityInfo={suitabilityInfo}
              practiceSignName={practiceSignName}
              practiceSignature={practiceSignature}
            />
          )}
          {currentPage === 6 && (
            // 계약전 알릴의무 표지
            <NotificationDuty
              isPracticeMode={true}
              onClickNext={handleNextClick}
              mainProductInfo={planMainInfo.mainProductInfo}
            />
          )}
          {currentPage === 7 && (
            // 계약전 알릴의무
            <NotificationEdit
              signPasteData={signData.app_form_etc_18}
              signData={signData.app_form_06}
              planMainInfo={planMainInfo}
              genderLabel={planMainInfo.ownerPrspInfo.genderLabel}
              applicationNo={applicationNo}
              empName={userInfo.username}
              isPracticeMode={true}
              onClickEaBookmark={handleEaBookmarkClick}
              insuredPrspCustNo={planMainInfo.insuredPrspCustNo}
              complete={completePage.includes(7)}
              bookmark={bookmark.filter(data => {
                if (data.title === '상품설명서(표지)') {
                  return true;
                } else {
                  if (data.ableYn && data.code !== '') {
                    return true;
                  } else {
                    return false;
                  }
                }
              })}
              mainProductInfo={planMainInfo.mainProductInfo}
              practiceSignName={practiceSignName}
              practiceSignature={practiceSignature}
              suitabilityInfo={suitabilityInfo}
            />
          )}
          {currentPage === 8 && (
            <EaPdfViewerMain
              currentPag={currentPage}
              pdfPageNum={pdfPageNum}
              setPdfPageNum={setPdfPageNum}
              jumpToPagePluginInstance={jumpToPagePluginInstance}
              custNo={planMainInfo.ownerPrspInfo.custNo}
              applicationNo={applicationNo}
              jumpToPage={jumpToPage}
              setCurrentPage={setCurrentPage}
              isPracticeMode={true}
              practiceSignName={practiceSignName}
              practiceSignature={practiceSignature}
            />
          )}
          {currentPage === 9 && (
            // 보험설계사 서명
            <LifePlannerSign
              applicationNo={applicationNo}
              empName={userInfo.username}
              empNumber={userInfo.userId}
              onClickNext={handleNextClick}
              isPracticeMode={true}
            />
          )}
          {currentPage === 10 && (
            // 계좌등록
            <RegisterAccountMain
              isPracticeMode={true}
              applicationNo={applicationNo}
              completePage={completePage}
              onClickNext={handlePageChange}
              practiceSignature={practiceSignature}
            />
          )}
        </div>
      </div>
      <SatModal
        visible={isClosePopup}
        setVisible={() => {
          setIsClosePopup(false);
        }}
        type="confirm"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {`대면 전자청약 연습모드를 종료 하시겠어요?`}
                  <br />
                  {`입력하신 정보는 저장되지 않습니다.`}
                </p>
              </div>
              <div className="btn-group">
                <SatButton
                  styleClass="btn-half cancel"
                  label={'취소'}
                  onClick={() => setIsClosePopup(false)}
                />
                <SatButton
                  styleClass="btn-half confirm"
                  label={'확인'}
                  onClick={() => {
                    setIsClosePopup(false);
                    handleCloseConfirmBtn();
                  }}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isAuthPopup}
        setVisible={() => {
          setIsAuthPopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">
                  {
                    '본인 인증 및 서명 등록이 되지 않아 다음 단계로 이동할 수 없습니다.'
                  }
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => setIsAuthPopup(false)}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isNotCompletePopup}
        setVisible={() => {
          setIsNotCompletePopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">{notCompleteMsg}</p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => pageJumpNotCompletePage()}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isCompletePopup}
        setVisible={() => {
          setIsCompletePopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">
                  {
                    '대면 전자청약 연습모드로 청약완료가 불가합니다. 전자청약 닫기 버튼을 통하여 연습모드 종료가능합니다. '
                  }
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => {
                    setIsCompletePopup(false);
                  }}
                />
              </div>
            </>
          );
        }}
      />
    </>
  );
};

export default EaPracticeMain;
